import GridWrapper from "@components/elements/GridWrapper";
import AccountForm from "@components/signup/account/form";
import { useAuth } from "@hooks/auth/useAuth";
import {
  Box,
  Divider,
  FormHelperText,
  Typography,
  Button,
} from "@material-ui/core";
import axios from "axios";
import React from "react";
import GoogleButton from "react-google-button";
import Link from "@material-ui/core/Link";
import { useRouter } from "next/router";

export default function SignupAccount(): JSX.Element {
  const router = useRouter();
  const [error, setError] = React.useState<string>(null);
  const { signup, googleAuth, authLogin } = useAuth();

  const returnTo = "/signup/plan";
  const navigateToPlan = () => {
    router.push(returnTo);
  };

  const onSignup = ({ email, password }) => {
    signup({ email, password })
      .then(() => {
        return authLogin({ email, password }, returnTo);
      })
      .catch((error) => {
        setError(error.description);
      });
  };

  const signupWithGoogle = () => {
    googleAuth({
      mode: "signUp",
      returnTo,
      fromPath: "/signup/account",
    }).catch((error) => {
      setError(error.description);
    });
  };

  return (
    <GridWrapper spacing={2}>
      <Typography variant="caption" component="h6" align="center">
        Step 1 of 3
      </Typography>
      <Typography variant="h6" align="center">
        Account setup
      </Typography>
      <Typography variant="body1" align="center">
        Set up your account to get started.
      </Typography>

      <AccountForm onSubmit={onSignup} />

      <Divider />

      <Box display="flex">
        <GoogleButton
          style={{ flex: 1 }}
          type="dark"
          label="Sign up with Gooogle"
          onClick={signupWithGoogle}
        />
      </Box>

      {!!error && <FormHelperText>{error}</FormHelperText>}

      <Box mt={4}>
        <Typography variant="subtitle1">
          Already have an account?{" "}
          <Link href="/login">
            <Button variant="text" size="small">
              Login Now
            </Button>
          </Link>
        </Typography>
        <Typography variant="caption" color="textSecondary">
          This page is protected by Google reCAPTCHA to ensure you're not a bot.
        </Typography>
      </Box>
    </GridWrapper>
  );
}
